// @flow
import $ from 'jquery';

/**
 * Odscrollování na kotvu nebo jQuery element
 */
export default (): void => {

  window.scrollToAnchor = function (element, customOffset) {
  	let targetOffset = parseInt(customOffset) || 0;
    let navToggle = $("button.navbar-toggle");
  	// pokud existuje pevná horní lišta, započte do scrollu i její výšku
  	if ($('nav.navbar').height() > 0 ) {
  		targetOffset += parseInt($(element).offset().top - ($('nav.navbar').outerHeight()));
  	} else {
  		targetOffset += parseInt($(element).offset().top);
  	}
  	// pokud je otzevřené menu zavřeme jej
    if(!navToggle.hasClass('collapsed')) {
      navToggle.trigger('click');
    }
  	$('html,body').animate({scrollTop:targetOffset}, 1800);
  };
  // animace scrollu na hash
  $('.js_scroll').on('click', function (e) {
  	e.preventDefault();
  	scrollToAnchor($(this.hash));
  });

  /*!
   Back top link
   */
  $('html').on("click", "#back-top", function (e) {
    e.preventDefault();
    $('html, body').animate({'scrollTop': 0});
  });
  $(window).scroll(function () {
    var st = $(window).scrollTop(),
        backToTop = $('#back-top');
    if (st > 480) {
      backToTop.addClass('show');
    }
    else {
      backToTop.removeClass('show');
    }
  });


};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/menuScroll.js